// extracted by mini-css-extract-plugin
export var label = "_d9-2";
export var slideContainer = "_d9-0";
export var slider = "_d9-1";